export default "__VITE_ASSET__DbTR8bw7__"